import { render, staticRenderFns } from "./CommentsShowMore.vue?vue&type=template&id=16541533&scoped=true&"
import script from "./CommentsShowMore.vue?vue&type=script&lang=js&"
export * from "./CommentsShowMore.vue?vue&type=script&lang=js&"
import style0 from "./CommentsShowMore.vue?vue&type=style&index=0&id=16541533&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16541533",
  null
  
)

export default component.exports